import React, { useEffect } from "react";

import { usePageTitle } from "@/atoms/page-title-atom";
import { useSalesBreakdownConfigs } from "@components/data/sales-breakdown-configs";
import { LogOnMount } from "@components/v2/analytics";

import { Overview } from "./overview";

function OverviewPage(): JSX.Element {
  const { value: breakdownConfigs } = useSalesBreakdownConfigs();
  const [, setPageTitle] = usePageTitle();
  useEffect(() => {
    setPageTitle("Overview");
  }, [setPageTitle]);

  return (
    <>
      <LogOnMount name="Visit overview page" />
      <Overview
        breakdownConfigs={breakdownConfigs}
        reportEventName="Request Overview Report"
      />
    </>
  );
}

export default OverviewPage;
